import * as OvationsApi from 'core/ovations-api';

export const mockPromotionQuestionAnswer: OvationsApi.Types.PromotionQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.None,
};

export const mockPromotionTextQuestionAnswer: OvationsApi.Types.PromotionTextQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.Text,
    value: '1',
};

export const mockPromotionNumberQuestionAnswer: OvationsApi.Types.PromotionNumberQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.Number,
    value: 2,
};

export const mockPromotionDropdownQuestionAnswer: OvationsApi.Types.PromotionDropDownQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.Dropdown,
    value: '3',
};

export const mockPromotionCascadingDropdownQuestionAnswer: OvationsApi.Types.PromotionCascadingDropdownQuestionAnswer =
    {
        type: OvationsApi.Enums.QuestionType.CascadingDropdown,
        values: { 1: 'First layer answer', 2: 'Last layer answer' },
    };

export const mockPromotionDateTimeQuestionAnswer: OvationsApi.Types.PromotionDateTimeQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.DateTime,
    value: '2018-06-04T05:00:00Z',
};

export const mockPromotionFileUploadQuestionAnswer: OvationsApi.Types.PromotionFileUploadQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.FileUpload,
    fileName: 'mockFileUrl.jpg',
    fileLocation: 'claim-files/mockFileUrl.jpg',
    fileUrl: 'https://example.com/claim-files/mockFileUrl.jpg',
    file: null,
};

export const mockPromotionMultiSelectQuestionAnswer: OvationsApi.Types.PromotionMultiSelectQuestionAnswer = {
    type: OvationsApi.Enums.QuestionType.MultiSelect,
    selections: ['test1', 'test2', 'test3'],
};
